import React, { useEffect, useState } from "react";
import { useLang } from "../i18n";
import { api } from "../api";
import { AreaChart, Area, XAxis, YAxis, ResponsiveContainer, Tooltip } from "recharts";
import { TrendingDown } from "lucide-react";

export function BioAge() {
  const { t } = useLang();
  const [hist, setHist] = useState(null);

  useEffect(() => {
    api.get("/bio-age/history").then((r) => setHist(r.data)).catch(() => {});
  }, []);

  if (!hist || !hist.series || !hist.series.length || !hist.chrono) return null;

  const series = hist.series;
  const chrono = hist.chrono;
  const bio = series[series.length - 1].bio;
  const delta = Math.round((chrono - bio) * 10) / 10;

  return (
    <div className="rounded-3xl p-8 bg-[#2B4A59] text-[#FDFBF7] relative overflow-hidden mb-8" data-testid="bio-age">
      <div className="grain opacity-40" />
      <div className="relative">
        <p className="text-xs uppercase tracking-widest text-white/50 mb-4">{t("bio_trend_title")}</p>

        <div className="flex items-end gap-6 mb-6">
          <div>
            <p className="font-serif text-6xl leading-none" style={{ color: delta > 0 ? "#8FD9A8" : "#FDFBF7" }} data-testid="bio-value">{bio}</p>
            <p className="text-[11px] text-white/60 mt-1">{t("bio_title")}</p>
          </div>
          <span className="text-white/40 text-xl pb-2">vs</span>
          <div>
            <p className="font-serif text-5xl leading-none text-white/80">{chrono}</p>
            <p className="text-[11px] text-white/60 mt-1">{t("chrono_age")}</p>
          </div>
          {delta > 0 && (
            <span className="ml-auto inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm font-semibold bg-[#8FD9A8]/20 text-[#8FD9A8]" data-testid="bio-delta">
              <TrendingDown className="w-4 h-4" /> −{delta} {t("bio_younger")}
            </span>
          )}
        </div>

        <div className="h-40" data-testid="bio-trend-chart">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={series} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
              <defs>
                <linearGradient id="bioGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#8FD9A8" stopOpacity={0.5} />
                  <stop offset="100%" stopColor="#8FD9A8" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="label" tick={{ fontSize: 11, fill: "rgba(255,255,255,0.5)" }} axisLine={false} tickLine={false} />
              <YAxis domain={["dataMin - 1", "dataMax + 1"]} tick={{ fontSize: 11, fill: "rgba(255,255,255,0.5)" }} axisLine={false} tickLine={false} width={36} />
              <Tooltip contentStyle={{ background: "#1c333d", border: "none", borderRadius: 12, color: "#fff" }} />
              <Area type="monotone" dataKey="bio" name={t("bio_title")} stroke="#8FD9A8" strokeWidth={2.5} fill="url(#bioGrad)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        <p className="text-[11px] text-white/40 mt-3">{t("bio_note")}</p>
      </div>
    </div>
  );
}
